import { createExchangeRateService } from '@ikhua/shared';
import apiClient from './apiClient';

export const getExchangeRate = createExchangeRateService(apiClient);
